import { render, staticRenderFns } from "./swiper-pagination.vue?vue&type=template&id=ab19d9aa&scoped=true&"
import script from "./swiper-pagination.vue?vue&type=script&lang=js&"
export * from "./swiper-pagination.vue?vue&type=script&lang=js&"
import style0 from "./swiper-pagination.vue?vue&type=style&index=0&id=ab19d9aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab19d9aa",
  null
  
)

export default component.exports